// FileProcessed.js


import './styles.css';
import React, { useState, useEffect } from 'react';
import './styles.css';
import axios from 'axios';
import HeaderLogged from './HeaderLogged';
import Sidebar from './Sidebar';
import { Link, json, useParams, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import JsonViewer from 'react-json-prettify';
import { googlecode } from 'react-json-prettify/dist/themes';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

const FileProcessed = ({ fileprocessed = {}}) => {
  const { itemId } = useParams();
  const [jsonFormData, setJsonFormData] = useState();
  const [jsonData, setJsonData] = useState(); 
  const [expandedFields, setExpandedFields] = useState({});
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const fileName = searchParams.get('fileName');
  const type = searchParams.get('type');
  const navigate = useNavigate();

  useEffect(() => 
    {
    //verificar se o usuário está logado
    if (localStorage.getItem("user") === null) {
      window.location.href = "/";

    }
    else {

      const data = JSON.parse(localStorage.getItem("user"));
    }
  })
  
  useEffect(() => {
    const formJson = async (itemID) => {
      try {
        const formData = new FormData();
        formData.append('ID', itemID);

        const response = await axios.post(
          process.env.REACT_APP_BASE_URL + '/api/ReturnData',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: 'Bearer 55c2fad3-45a4-4e29-b9cf-911d7cf6131f',
            }
          }
        );
        
        var jsonUnformatted = response.data.jsonData;
        const jsonFormatted = JSON.parse(jsonUnformatted);
        setJsonFormData(jsonFormatted);

        jsonUnformatted = jsonUnformatted.replace(/\\n/g, '').replace(/\\r/g, '').replace(/\\"""/g, '').replace(/\\/g, '');
        const jsonFormattedData = JSON.parse(jsonUnformatted);
        // setJsonData(JSON.stringify(jsonFormattedData, undefined, 2))
        setJsonData((jsonFormattedData))
        
      } catch (error) {
        console.error(error);
      }
    };

    formJson(itemId);
  }, [itemId]);

  useEffect(() => 
    {
      const getConfiguration = async (type, itemId) => {
        try {
          const fileType = new FormData();
          fileType.append('configuration', type);
  
          const response = await axios.post(
            process.env.REACT_APP_BASE_URL + '/api/ReadConfigurationPage',
            fileType,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: 'Bearer 55c2fad3-45a4-4e29-b9cf-911d7cf6131f',
              }
            }
          );

          if(response.data == "FileProcessedScore") {
            navigate("/fileProcessedScore/" + itemId)
          }
        } catch (error) {
          console.error(error);
        }
      };

      getConfiguration(type, itemId);

      
    }, [itemId, type]);

  const toggleFieldExpansion = (key) => {
    setExpandedFields({
      ...expandedFields,
      [key]: !expandedFields[key],
    });
  };

  const renderObjectInputs = (obj) => {
    return Object.entries(obj).map(([subKey, subValue]) => (
      <div key={subKey} className='mb-4'>
        <label htmlFor={subKey}><strong>{subKey}:</strong></label>
        {typeof subValue === 'object' && subValue !== null ? renderObjectInputs(subValue) : (
          <input type="text" id={subKey} className="form-control" value={subValue} readOnly />
        )}
      </div>
    ));
  };
  
  const renderFieldValue = (key, value) => {
    if (typeof value === 'object' && value !== null) {
      const isExpanded = expandedFields[key];
      return (
        <div>
          <button className='btn' onClick={() => toggleFieldExpansion(key)}>
            {isExpanded ? 
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-dash-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"/>
            </svg> :
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-plus-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
            </svg>
            }
          </button>
          {isExpanded && (
            <div className='d-flex flex-column'>
              {renderObjectInputs(value)}
            </div>
          )}
        </div>
      );
    } else {
      return <input type="text" className="form-control" value={value} readOnly />;
    }
  };

  return (
    <div>
    <div className="container-fluid p-0">
      <HeaderLogged />
      <div className="row showContentMargin">
        <div className="col-3 col-lg-auto col-xxl-2" id='divSidebar'>
          <Sidebar></Sidebar>
        </div>
        <main className="container col-lg-10 col-xxl-9 p-4" id='divContent'>
          <div className="row">
            <h4 className='text-center'>{fileName}</h4>
            <h4 className='text-center mb-4'>{type}</h4>
            {jsonData && Object.entries(jsonFormData).map(([key, value]) => (
                <div className="col-md-6 mb-3" key={key}>
                  <div className="row">
                      <label htmlFor={key} className="col-md-4 fs-5">{key}</label>
                    <div className="col-md-8">
                      {renderFieldValue(key, value)}
                    </div>
                  </div>
                </div>
              ))}
              <div className="col-md-12 text-center mt-4">
                <button className="btn btn-success btn-lg" type="button" data-bs-toggle="collapse" data-bs-target="#json" aria-expanded="false">
                  Json
                </button>
                <a type="submit" href='/fileupload' className="btn btn-success btn-lg ms-3">
                  Novo Processamento
                </a>
              </div>

                <div className='d-flex align-items-center justify-content-center'>
                  {jsonData && (
                    <div className='col-md-8 mt-4'>
                      <div className='card'>
                        <div className="collapse" id="json">
                        <JsonViewer
                          json={jsonData}
                          theme={googlecode} //colorBrewer //googlecode //monoBlue
                          padding={4}
                          indent={0}
                        />

                          {/* <textarea className="mt-4" value={jsonData} readOnly rows={13} cols={50} /> */}
                        </div>
                      </div>    
                    </div>
                  )}
              </div>  
          </div>
        </main>
      </div>
    </div>
  </div>
  );
};

export default FileProcessed;